<template>
  <div :class="prefixCls">
    <a-tabs v-model:value="currentTab" @change="handleTabChange">
      <a-tab-pane v-for="v in icons" :key="v.key">
        <template v-slot:tab>
          <span :style="{ fontSize: '10px' }">
            {{ v.title }}
          </span>
        </template>
        <ul v-if="v.key != 'custom'">
          <li
            v-for="(icon, key) in v.icons"
            :key="`${v.key}-${key}`"
            :class="{ active: selectedIcon == icon }"
            @click="handleSelectedIcon(icon)"
          >
            <a-icon :type="icon" :style="{ fontSize: '24px' }" />
          </li>
        </ul>
        <ul v-if="v.key == 'custom'">
          <li
            v-for="(icon, key) in v.icons"
            :key="`${v.key}-${key}`"
            :class="{ active: selectedIcon == icon }"
            @click="handleSelectedIcon(icon)"
          >
            <template v-if="icon && allIcon && allIcon[icon + 'Icon']">
              <component 
                :is="allIcon[icon + 'Icon']" 
                :style="{ fontSize: '24px' }"
                :key="`icon-${icon}`"
              />
            </template>
            <a-icon
              v-else-if="icon"
              :type="icon"
              :style="{ fontSize: '24px' }"
            />
          </li>
        </ul>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../utils/gogocodeTransfer'
import icons from './icons'

export default {
  name: 'IconSelect',
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-icon-selector',
    },
    // eslint-disable-next-line
    value: {
      type: String,
    },
    svgIcons: {
      type: Array,
      required: true,
    },
    allIcon: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedIcon: this.value || '',
      currentTab: 'custom',
      icons: icons,
    }
  },
  watch: {
    value(val) {
      this.selectedIcon = val
      this.autoSwitchTab()
    },
  },
  created() {
    if (this.value) {
      this.autoSwitchTab()
    }
    const custom = [
      {
        key: 'custom',
        title: '自定义图标',
        icons: this.svgIcons,
      },
    ]
    this.icons = custom.concat(this.icons)
  },
  methods: {
    handleSelectedIcon(icon) {
      this.selectedIcon = icon
      $emit(this, 'change', icon)
    },
    handleTabChange(activeKey) {
      this.currentTab = activeKey
    },
    autoSwitchTab() {
      const icons = this.icons
      icons.some(
        (item) =>
          item.icons.some((icon) => icon === this.value) &&
          (this.currentTab = item.key)
      )
    },
  },
  emits: ['change', 'update:value', , , 'update:value'],
}
</script>

<style lang="less" scoped>
@import '../index.less';
ul {
  list-style: none;
  padding: 0;
  overflow-y: scroll;
  height: 250px;
  li {
    display: inline-block;
    padding: @padding-sm;
    margin: 3px 0;
    border-radius: @border-radius-base;

    &:hover {
      cursor: pointer;
      background-color: #f5f5f5;
    }
    &.active {
      cursor: pointer;
      color: @white;
      background-color: @primary-color;
    }
  }
}
</style>
